<script>
import { debounce } from 'lodash';
import Vue from 'vue';

export default Vue.extend({
  name: 'InputQuantite',
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    label: {
      type: String,
      default: 'Quantité'
    },
    rules: {
      type: Array,
      default: () => ([])
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxQuantite: {
      type: Number,
      required: true
    },
    minQuantite: {
      type: Number,
      required: true
    },
    step: {
      type: Number,
      default: 1
    },
    hideButtons: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    inner_value: null,
    touched: false
  }),
  watch: {
    value (value) {
      this.inner_value = value;
    },
    inner_value: debounce(function (value) {
      if (value === '' || value === null || value === undefined || isNaN(value)) {
        this.inner_value = null;
      } else {
        if (typeof value === 'string') {
          this.inner_value = parseFloat(value.replace(',', '.'));
        }

        if (value < 0 || isNaN(value)) {
          this.inner_value = 0;
        }
      }

      // eslint-disable-next-line eqeqeq
      if (this.value != this.inner_value) {
        this.updateValue();
      }
    }, 50)
  },
  created () {
    this.inner_value = this.value;
  },
  methods: {
    updateValue () {
      this.$emit('input', this.inner_value);
      this.$emit('changeValue', this.inner_value);
    },
    onBlur () {
      this.touched = true;
    },
    onTouch () {
      this.touched = true;
    },
    incrementQuantite () {
      if (this.inner_value === null || this.inner_value === undefined) {
        this.inner_value = this.minQuantite;
      } else {
        let value = ((this.inner_value * 1000) + (this.step * 1000)) / 1000; // fix floating point errors

        if (value > this.maxQuantite) {
          value = this.maxQuantite;
        }
        if (value < this.minQuantite) {
          value = this.minQuantite;
        }

        this.inner_value = value;
      }
      (this.$refs.input).focus();
      (this.$refs.input).blur();
    },
    decrementQuantite () {
      if (this.inner_value === null || this.inner_value === undefined) {
        this.inner_value = this.minQuantite;
      } else {
        let value = ((this.inner_value * 1000) - (this.step * 1000)) / 1000; // fix floating point errors

        if (value > this.maxQuantite) {
          value = this.maxQuantite;
        }
        if (value < this.minQuantite) {
          value = this.minQuantite;
        }
        this.inner_value = value;
      }
      (this.$refs.input).focus();
      (this.$refs.input).blur();
    }
  }
});
</script>

<template>
  <div class="quantite-cnt">
    <div>
      <NumberField
        ref="input"
        v-model="inner_value"
        type="number"
        lang="en"
        :label="label"
        validate-on-blur
        :error="!!(rules && rules.length)"
        :disabled="disabled"
        hide-details
        :step="step"
        @blur="onBlur()"
        @change="onTouch()"
      >
        <template v-slot:prepend v-if="!hideButtons">
          <v-icon
            class="currentColor"
            @click="decrementQuantite()"
          >
            mdi-minus-circle
          </v-icon>
        </template>
        <template v-slot:append-outer v-if="!hideButtons">
          <v-icon
            class="currentColor"
            @click="incrementQuantite()"
          >
            mdi-plus-circle
          </v-icon>
        </template>
      </NumberField>
    </div>

    <v-input
      v-if="touched && rules && rules.length"
      error
      :messages="rules"
      style="width:100%"
    />
  </div>
</template>

<style lang="scss" scoped>
.quantite-cnt {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  & .v-text-field::v-deep input {
    width: 5em;
  }
}

.unite,
.unite * {
  display: inline !important;
}
</style>
